import React, { Component, Fragment } from 'react'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/service/computrepair.png'
import { Link } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class ComputerRepair extends Component {
     render() {
          return (
               <Fragment>
                        
              <Container fluid={true}  className="BetweenTwoSection">

                                  <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Service </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/computerrepair"> computer Repair</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
        <h2 className="section-title text-center mb-2 text-primary"> COMPUTER REPAIR AND MAINTANANCE</h2>

<p className="text-center mb-3"> Fast and reliable computer repair and maintenance services</p>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
           <img  className=""  src={Product1}  alt="ParkEase Dashboard"/>
          
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4></h4>
         
            <p>At ChrisAlpha Tech Company, we provide professional computer repair and maintenance services to keep your systems running smoothly. Our skilled technicians diagnose and fix hardware and software issues, remove viruses, upgrade systems, and perform routine maintenance to improve performance and reliability.
</p>
          <p>
We offer fast and reliable computer repair and maintenance services to ensure your devices operate efficiently and securely.
</p>
        
          <div className="">
           <ul>
  <li>Computer hardware repair and replacement</li>
  <li>Software installation and troubleshooting</li>
  <li>Virus and malware removal</li>
  <li>System upgrades and performance optimization</li>
  <li>Data backup and recovery</li>
  <li>Laptop and desktop maintenance</li>
  <li>Operating system installation</li>
  <li>Preventive maintenance services</li>
</ul>
         

          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2"></h6>
          <h6>We handle everything from slow computers and virus removal to hardware replacement 
            and system upgrades. Whether you are a business, school, or individual, our team ensures your computers remain secure, fast, and dependable.
             With regular maintenance and expert repairs, we help extend the lifespan of your devices and improve overall performance.</h6>
           
        
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <p className=" p-0 m-0"><span className="Review-Title"> Professional and Affordable </span><span className="text-success"> </span>    </p>
          <p>"The repair service was fast and affordable. They replaced my faulty hardware and upgraded my system. I am very satisfied with the results."</p>

          <p className=" p-0 m-0"><span className="Review-Title">Great Customer Experience</span> <span className="text-success"> </span> </p>
          <p>"Whenever we have computer problems, Chrisalpha Tech responds quickly and solves the issue. Their team is knowledgeable and trustworthy.".</p>

          </Col>
     </Row>
</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default ComputerRepair